import React, { memo } from "react";

import Grid from "@material-ui/core/Grid";

import {
  ControlledLifeCycleInput,
  DollarDisplayCentsInputProps,
  SelectField,
  withNamespace,
} from "components/Form/FormikControls";

import { PAYMENT_METHOD_OPTIONS, PaymentMethod } from "constants/payments";
import { useFieldValue } from "hooks";
import { CashPaymentMethodForm } from "./PaymentMethodForm/CashPaymentMethodForm";
import { CardPaymentMethodForm } from "./PaymentMethodForm/CardPaymentMethodForm";
import { CommonPaymentFields } from "./PaymentMethodForm/CommonPaymentMethodFields";

interface EditPaymentFormProps {
  namespace?: string;
}

const PaymentMethodComponentMap = {
  [PaymentMethod.CASH]: CashPaymentMethodForm,
  [PaymentMethod.CARD]: CardPaymentMethodForm,
};

function EditPaymentFormComponent(props: EditPaymentFormProps) {
  const { namespace: ns = "" } = props;

  const paymentMethod: PaymentMethod = useFieldValue(
    withNamespace(ns, "paymentMethod"),
  );

  const paymentAmountCents: number = useFieldValue(
    withNamespace(ns, "totalAmountCents"),
  );

  const PaymentMethodFormComponent = PaymentMethodComponentMap[paymentMethod];

  return (
    <>
      <Grid item sm={6}>
        <ControlledLifeCycleInput
          {...DollarDisplayCentsInputProps}
          label="Payment amount ($)"
          name={withNamespace(ns, "totalAmountCents")}
          required
        />
      </Grid>
      <Grid item sm={6}>
        <SelectField
          label="Method"
          name={withNamespace(ns, "paymentMethod")}
          required
          options={PAYMENT_METHOD_OPTIONS}
        />
      </Grid>
      {PaymentMethodFormComponent ? (
        <PaymentMethodFormComponent
          namespace={ns}
          paymentAmountCents={paymentAmountCents}
        />
      ) : (
        <CommonPaymentFields namespace={ns} />
      )}
    </>
  );
}

export const EditPaymentForm = memo(EditPaymentFormComponent);
